import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'externalizeLinks',
})
export class ExternalizeLinksPipe implements PipeTransform {
  // Bloodmagic happens if we try to use <a[^>]+href=["']([^"']+)["'][^>]*>([^<]+)<\/a> for matching,
  // so we use two separate regexes
  private anchorTagRegexDoubleQuote = new RegExp(/<a[^>]+href="([^"]+)"[^>]*>([^<]+)<\/a>/g);
  private anchorTagRegexSingleQuote = new RegExp(/<a[^>]+href='([^']+)'[^>]*>([^<]+)<\/a>/g);

  transform(html: string) {
    if (!html) {
      return html;
    }

    html = this.parse(html, this.anchorTagRegexDoubleQuote);
    html = this.parse(html, this.anchorTagRegexSingleQuote);

    return html;
  }

  private parse(html: string, regex: RegExp) {
    let link;

    while ((link = regex.exec(html)) !== null) {
      const anchorTag = link[0];
      const href = link[1];
      const text = link[2];

      const escapedAnchorTag = anchorTag.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      const externalAnchorTag = `<a href="${href}" target="_blank" rel="noopener">${text}</a>`;

      html = html.replace(new RegExp(escapedAnchorTag, 'g'), externalAnchorTag);
    }

    return html;
  }
}
